import styled from 'styled-components'

import { colors } from '../../styles/colors'

interface IStyledTabProps {
  background: string
}

export const StyledTab = styled.div<IStyledTabProps>`
  background: ${props => colors[props.background]};
  display: flex;
  width: 100%;
  border-bottom: 2px solid ${colors.grayExtraLight};
`
